// extracted by mini-css-extract-plugin
export default {"personalProcessingAgreement":"DEFormFields_personalProcessingAgreement__g6whO"};